import React from 'react';
import { injectIntl } from 'react-intl';

import { Modal } from 'sa-ui';

import messages from './classesStudentsUploadAnswerConfirmationModalMessages';

function ClassesStudentsUploadAnswerConfirmationModal({ isOpen, onClose, amount, intl }) {
  return (
    <Modal
      show={isOpen}
      onClose={onClose}
      icon="ti-thumb-up"
      title={intl.formatMessage(messages.title)}
      subtitle={intl.formatMessage(messages.subtitle, { amount })}
      buttons={[
        {
          label: intl.formatMessage(messages.close),
          onClick: onClose,
          primary: true,
        },
      ]}
      small
    />
  );
}

export default injectIntl(ClassesStudentsUploadAnswerConfirmationModal);
